function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var DatabaseTemplate = require('./database.template');
var AdminDatabaseUI = /*#__PURE__*/function () {
  function AdminDatabaseUI(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.admin-database';
    _classCallCheck(this, AdminDatabaseUI);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.databases = [];
    this.db = '';
    this.tables = [];
    this.table = '';
    this.schema = [];
    this.sql = '';
    this.rows = null;
    this.status = '';
    this.error = '';
    this.busy = '';
  }
  return _createClass(AdminDatabaseUI, [{
    key: "render",
    value: function render() {
      this.databases = [];
      this.db = '';
      this.tables = [];
      this.table = '';
      this.schema = [];
      this.sql = '';
      this.rows = null;
      this.status = '';
      this.error = '';
      this.busy = '';
      if (!this.mod.server_info) {
        this.app.browser.replaceElementContentBySelector("<p class=\"admin-db-empty\">Waiting for the server to finish authenticating this administrator.</p>", this.container);
        return;
      }
      this.refresh();
      this.loadDatabases();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.app.browser.replaceElementContentBySelector(DatabaseTemplate({
        databases: this.databases,
        db: this.db,
        tables: this.tables,
        table: this.table,
        schema: this.schema,
        sql: this.sql,
        status: this.status,
        error: this.error,
        busy: this.busy
      }), this.container);
      this.attachEvents();
      this.paintSchema();
      this.paintResults();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var dbSelect = document.getElementById('admin-db-select');
      if (dbSelect) {
        dbSelect.onchange = function () {
          _this.db = dbSelect.value;
          _this.tables = [];
          _this.table = '';
          _this.schema = [];
          _this.rows = null;
          _this.status = '';
          _this.error = '';
          _this.refresh();
          if (_this.db) {
            _this.loadTables();
          }
        };
      }
      var tableSelect = document.getElementById('admin-db-table');
      if (tableSelect) {
        tableSelect.onchange = function () {
          _this.table = tableSelect.value;
          _this.schema = [];
          _this.rows = null;
          _this.status = '';
          _this.error = '';
          if (!_this.table) {
            _this.refresh();
            return;
          }
          _this.sql = "SELECT * FROM ".concat(_this.quoteIdent(_this.table), " LIMIT 20;");
          _this.refresh();
          _this.loadSchema();
          _this.runQuery();
        };
      }
      var sqlInput = document.getElementById('admin-sql-input');
      if (sqlInput) {
        sqlInput.oninput = function (e) {
          _this.sql = e.currentTarget.value;
        };
      }
      var runBtn = document.getElementById('admin-sql-run');
      if (runBtn) {
        runBtn.onclick = function () {
          return _this.runQuery();
        };
      }
    }
  }, {
    key: "quoteIdent",
    value: function quoteIdent(name) {
      return "\"".concat(String(name).replace(/"/g, '""'), "\"");
    }
  }, {
    key: "loadDatabases",
    value: function loadDatabases() {
      var _this2 = this;
      this.busy = 'databases';
      this.request('list-databases', {}, function (result, err) {
        _this2.busy = '';
        if (err) {
          _this2.error = err;
          _this2.refresh();
          return;
        }
        _this2.databases = result || [];
        _this2.refresh();
      });
    }
  }, {
    key: "loadTables",
    value: function loadTables() {
      var _this3 = this;
      this.busy = 'tables';
      this.request('list-database-tables', {
        db: this.db
      }, function (result, err) {
        _this3.busy = '';
        if (err) {
          _this3.error = err;
          _this3.tables = [];
          _this3.refresh();
          return;
        }
        _this3.tables = (result || []).map(function (row) {
          return row.name || row;
        }).filter(Boolean);
        _this3.refresh();
      });
    }
  }, {
    key: "loadSchema",
    value: function loadSchema() {
      var _this4 = this;
      var sql = "PRAGMA table_info(".concat(this.quoteIdent(this.table), ")");
      this.request('run-sql-query', {
        db: this.db,
        query: sql
      }, function (result, err) {
        if (err) {
          _this4.error = err;
          _this4.schema = [];
          _this4.refresh();
          return;
        }
        _this4.schema = (result === null || result === void 0 ? void 0 : result.rows) || [];
        _this4.refresh();
      });
    }
  }, {
    key: "runQuery",
    value: function runQuery() {
      var _document$getElementB,
        _this5 = this;
      var sql = (this.sql || ((_document$getElementB = document.getElementById('admin-sql-input')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.value) || '').trim();
      this.sql = sql;
      if (!this.db) {
        this.error = 'Select a database first. Queries always run against the selected database.';
        this.rows = null;
        this.status = '';
        this.refresh();
        return;
      }
      if (!sql) {
        this.error = 'Enter SQL to run against "' + this.db + '".';
        this.refresh();
        return;
      }
      this.busy = 'sql';
      this.error = '';
      this.status = '';
      this.refresh();
      this.request('run-sql-query', {
        db: this.db,
        query: sql
      }, function (result, err) {
        _this5.busy = '';
        if (err) {
          _this5.error = err;
          _this5.rows = null;
          _this5.status = '';
          _this5.refresh();
          return;
        }
        if (result !== null && result !== void 0 && result.rows) {
          _this5.rows = result.rows;
          _this5.status = result.rows.length === 0 ? "Query on \"".concat(_this5.db, "\" returned no rows.") : "Query on \"".concat(_this5.db, "\" returned ").concat(result.rows.length, " row").concat(result.rows.length === 1 ? '' : 's', ".");
        } else {
          _this5.rows = null;
          var changes = result === null || result === void 0 ? void 0 : result.changes;
          _this5.status = "Statement on \"".concat(_this5.db, "\" completed.").concat(typeof changes === 'number' ? " ".concat(changes, " row").concat(changes === 1 ? '' : 's', " changed.") : '').concat((result === null || result === void 0 ? void 0 : result.lastID) != null && result.lastID !== 0 ? " lastID ".concat(result.lastID, ".") : '');
        }
        _this5.refresh();
      });
    }
  }, {
    key: "paintSchema",
    value: function paintSchema() {
      var el = document.getElementById('admin-db-schema');
      if (!el) {
        return;
      }
      el.innerHTML = '';
      if (!this.schema.length) {
        return;
      }
      el.appendChild(this.buildTable(this.schema, ['name', 'type', 'notnull', 'dflt_value', 'pk']));
    }
  }, {
    key: "paintResults",
    value: function paintResults() {
      var el = document.getElementById('admin-db-output');
      if (!el) {
        return;
      }
      el.innerHTML = '';
      if (!this.rows || !this.rows.length) {
        return;
      }
      el.appendChild(this.buildTable(this.rows));
    }
  }, {
    key: "buildTable",
    value: function buildTable(rows, columns) {
      var keys = columns || Object.keys(rows[0] || {});
      var table = document.createElement('table');
      table.className = 'admin-db-table';
      var thead = document.createElement('thead');
      var hr = document.createElement('tr');
      keys.forEach(function (key) {
        var th = document.createElement('th');
        th.textContent = key;
        hr.appendChild(th);
      });
      thead.appendChild(hr);
      table.appendChild(thead);
      var tbody = document.createElement('tbody');
      rows.forEach(function (row) {
        var tr = document.createElement('tr');
        keys.forEach(function (key) {
          var td = document.createElement('td');
          var value = row[key];
          if (value === null || value === undefined) {
            td.textContent = 'NULL';
            td.className = 'admin-db-null';
          } else {
            td.textContent = String(value);
          }
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      return table;
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(name, data, done) {
        var tx, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.mod.server_publickey);
            case 1:
              tx = _context.v;
              tx.msg = {
                module: 'Admin',
                request: name,
                data: data
              };
              _context.n = 2;
              return tx.sign();
            case 2:
              this.app.network.sendTransactionWithCallback(tx, function (res_tx) {
                var res = res_tx.returnMessage();
                if (res !== null && res !== void 0 && res.err) {
                  done(null, res.err);
                } else {
                  done(res === null || res === void 0 ? void 0 : res.result, null);
                }
              }, this.mod.server_publickey);
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              done(null, _t.message || String(_t));
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[0, 3]]);
      }));
      function request(_x, _x2, _x3) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }]);
}();
module.exports = AdminDatabaseUI;